// extracted by mini-css-extract-plugin
export default {"imageWrapper":"QK-z","twoColumnImage":"RK-z"};